import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.18 Case 18</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="challenge_case_18"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 18. This is a negative case. The
                size and contrast have already been adjusted. Starting at the
                base of the cerebellum, you can see there is good gray-white
                contrast here.
              </p>
              <p>
                As you move superiorly, you enter into the temporal lobes, seen here on the left as well as on the right. Increased activity is seen within the white matter tracts bilaterally, and this is surrounded by less intense activity in the gray matter. Therefore there is preserved gray-white contrast in both temporal lobes.
              </p>
              <p>
                As we move superiorly and enter into the occipital lobes
                posteriorly as well as the frontal lobes anteriorly, this
                pattern continues. Again, no increased activity is seen in the
                cortical gray matter. In the frontal lobes, fingerlike
                projections of white matter are seen bilaterally surrounded by
                less intense gray matter.
              </p>
              <p>
                Moving into the parietal lobes, intense activity is seen
                linearly in the white matter tracts. This pattern continues as
                we move all the way to the top of the brain. Going back to the
                precuneus, no increased activity is seen in this region either.
                This can be confirmed in the sagittal plane as well.
              </p>
              <p>
                Since there is preserved gray-white contrast in all regions,
                this is a negative scan. If you called this case positive, you
                may want to review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-17"
          nextLesson="/module-4/module-4-1-19"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_756850483&entry_id=1_w3ydecum&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_w3ydecum"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
